import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Tours from './views/Tours/Tours';
import Header from './components/Header';
import ThemedWalk from './views/Tours/ThemedWalk';
import QuickWalk from './views/Tours/QuickWalk';
import CuratedWalk from './views/Tours/CuratedWalk';
import Library from './views/Library/Library';
import Themes from './views/Library/Themes';
import PoemsMap from './views/Library/PoemsMap';
import Poems from './views/Library/Poems';
import Poets from './views/Library/Poets';
import About from './views/About/About';


function App() {
  return (
    <div className="App">
      <Router>
          <Header />
        <Container>
          <Row>
            <Switch>
              <Route exact path="/" component={Tours}  />
              <Route exact path="/quickwalk" component={QuickWalk}  />
              <Route exact path="/themedwalk" component={ThemedWalk}  />
              <Route exact path="/curatedwalk" component={CuratedWalk} />
              <Route exact path="/library" component={Library}  />
              <Route exact path="/poets" component={Poets}  />
              <Route exact path="/poems" component={Poems}  />
              <Route exact path="/poem-map" component={PoemsMap}  />
              <Route exact path="/themes" component={Themes}  />
              <Route exact path="/about" component={About}  />
            </Switch>
          </Row>
        </Container>
      </Router>
    </div>
  );
}

export default App;
